/* eslint-disable max-len */
import {
  IDLE_TIME_WAREHOUSE_ALLOW_LIST,
  REPORTING_WAREHOUSE_ALLOW_LIST,
  REQUEST_HELP_WAREHOUSE_ALLOW_LIST,
} from '../constants/featureGates';
import { UserDetails } from '../context/GlobalContext';

export const isRequestHelpEnabledForWarehouse = (warehouseId: string): boolean => (
  REQUEST_HELP_WAREHOUSE_ALLOW_LIST.includes(warehouseId)
);

export const isReportingEnabledForUser = (userDetails: UserDetails, isAdminViewEnabled: boolean): boolean => (
  (userDetails.isAdmin && isAdminViewEnabled) || REPORTING_WAREHOUSE_ALLOW_LIST.includes(userDetails.warehouseId)
);

export const isIdleTimeReportingEnabledForUser = (userDetails: UserDetails, isAdminViewEnabled: boolean): boolean => (
  (userDetails.isAdmin && isAdminViewEnabled) || IDLE_TIME_WAREHOUSE_ALLOW_LIST.includes(userDetails.warehouseId)
);
